export default __webpack_public_path__ + "static/media/SEPTDOM2025.2d2c81fe.png";